module.exports = __webpack_public_path__ + "media/audio2.23780582.mp3";